export default "__VITE_ASSET__e118f384__"